var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},_vm._l((_vm.presentCircles),function(c,i){return _c('div',{key:i},[_c('BgRowMap',{attrs:{"presentPercentage":1,"present":_vm.presentCircles[i]}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }